export default {
  "content": "<path d=\"M11.58 5.5H5.5v13h13v-4.893h2V19.5a1 1 0 01-1 1h-15a1 1 0 01-1-1v-15a1 1 0 011-1h7.08v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.57 2.054a1 1 0 011.334.068l2.617 2.606a1.002 1.002 0 01.003 1.414l-5.823 5.843a3.001 3.001 0 01-1.224.744l-3.36 1.056a1.001 1.001 0 01-1.257-1.249l1.038-3.355a3 3 0 01.75-1.24l5.845-5.819.076-.068zm-4.511 7.304a1 1 0 00-.25.414l-.475 1.533 1.543-.485c.154-.048.294-.133.408-.248l5.116-5.133-1.203-1.197-5.14 5.116z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};